import { useState } from 'react';

import { btn } from '@/components/ui/styles';
import http from '@/utils/http';

import { errorOf, useAssistant } from './use-assistant';

/**
 * One click on a lead's page (ASSIST-1): Assistant makes a Telegram group with the lead and
 * the team member who clicked, and introduces them. Only where Assistant is on.
 */
const AssistantGroupButton = ({ leadId, onDone }: { leadId: string; onDone: () => void }) => {
  const { data } = useAssistant();
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<string | null>(null);
  if (!data?.enabled) return null;

  const start = async () => {
    setBusy(true);
    setNote(null);
    try {
      await http.post(`/leads/${encodeURIComponent(leadId)}/assistant-group`);
      setNote('Group made on Telegram.');
      onDone();
    } catch (err) {
      setNote(errorOf(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        className={btn.secondary}
        onClick={start}
        disabled={busy || !data.connected}
        title={data.connected ? undefined : 'Assistant’s Telegram account is not connected'}
      >
        {busy ? 'Making the group…' : 'Start a Telegram group'}
      </button>
      {note && <span className="text-xs text-fg-muted">{note}</span>}
    </span>
  );
};

export default AssistantGroupButton;
